import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Link, useParams } from "react-router-dom";
import checkCircle from "../../assets/icons/check-circle.png";
import closeCircle from "../../assets/icons/close-circle.png";
import iconImage from "../../assets/icons/icon-image.png";
import ButtonImage from "../../components/Buttons/ButtonImage";
import ButtonZegel from "../../components/Buttons/ButtonZegel";
import DialogImage from "../../components/Dialog/DialogImage";
import FooterInterno from "../../components/Footer/FooterInterno";
import DashboardNavBarResultados from "../../components/Header/DashboardNavBarResultados";
import { buscarConfiguracion } from "../../helpers/helpers";
import useAlumno from "../../hooks/useAlumno";
import { BuscarEvaluacionPorId } from "../../services/EvaluacionService";
import {
  ListarPreguntasPorUnidad,
  ObtenerAlternativasPorUnidad,
  ObtenerRespuestaAlumnosPorEvaluacion,
} from "../../services/PreguntaService";
import "./styles/EvaluacionExamen.scss";

import { ListarUnidadesPorCurso } from "../../services/UnidadService";
import { ObtenerPersonaCurso } from "../../services/UsuarioService";
import CryptoJS from 'crypto-js';

const ResultadosExamen = (props) => {
  const { configuraciones, perfil } = useAlumno();
  let { IdPersonaCurso } = useParams();
  let { idEvaluacion } = useParams();
  let { idUnidad } = useParams();

  let correlativo = 0;
  const [listaPreguntas, setListaPreguntas] = useState(null);
  const [respuestasAlumnos, setRespuestasAlumnos] = useState(null);
  const [listaAlternativas, setListaAlternativas] = useState(null);
  const [evaluacion, setEvaluacion] = useState(null);

  const [notaMinima, setNotaMinima] = useState(null);

  const [showDialogImage, setShowDialogImage] = useState(null);
  const [imagenRecurso, setImagenRecurso] = useState(null);
  const [videoRecurso, setVideoRecurso] = useState(null);

  const [unidad, setUnidad] = useState(null);
  const [curso, setCurso] = useState(null);
  const [PersonaCurso, setPersonaCurso] = useState(null);
  const [listaUnidades, setListaUnidades] = useState(null);
  const [UnidadIndex, setUnidadIndex] = useState(0);

  useEffect(() => {
    if (idUnidad) {
      let jwt = window.localStorage.getItem("jwt");
      //let idUnidad = idCursoUsuario;
      /* if (perfil === null) {
        window.location.href = "/" + PrivateRoutes.HOME + "/Dashboard";
      } else {
        BuscarUnidadID({ jwt, idUnidad }).then((data) => {
          setUnidad(data);
        });
      } */
    }
  }, [idUnidad]);

  useEffect(() => {
    if (configuraciones) {
      let notaMIn = buscarConfiguracion(configuraciones, "NOTA_MINIMA_APROB");
      setNotaMinima(notaMIn);
    }
  }, [configuraciones]);

  useEffect(() => {
    if (idUnidad) {
      let jwt = window.localStorage.getItem("jwt");
      ListarPreguntasPorUnidad({ jwt, idUnidad }).then((data) => {
       
        if(data.length > 0){
          for(var j=0; j<data.length; j++){
            data[j].respuesta = Decrypt(data[j].respuesta);
          }
        }
        var preguntas = [];
        //var  preg = data
        var preguntasPaginadas = localStorage.getItem(
          "preguntasAleatoriasOrden"
        );
        preguntasPaginadas = JSON.parse(preguntasPaginadas);

        data.forEach((elemento) => {
          const Id_elemento = elemento.idPregunta;
          if (
            preguntasPaginadas.some(
              (respuesta) => respuesta.idPregunta === Id_elemento
            )
          ) {
            preguntas.push(elemento);
          }
        });

        if (preguntasPaginadas !== null) {
          preguntas = preguntas.sort((a, b) => {
            const indexA = preguntasPaginadas.findIndex(
              (resp) => resp.idPregunta === a.idPregunta
            );
            const indexB = preguntasPaginadas.findIndex(
              (resp) => resp.idPregunta === b.idPregunta
            );
            return indexA - indexB;
          });
        } else {
          console.error("preguntasTotales is null");
        }

        setListaPreguntas(preguntas);
      });
    }
  }, [idUnidad]);

  useEffect(() => {
    if (IdPersonaCurso) {
      let jwt = window.localStorage.getItem("jwt");
      ObtenerPersonaCurso({ jwt, IdPersonaCurso }).then((data) => {
        setPersonaCurso(data);
      });
    }
  }, [IdPersonaCurso]);

  useEffect(() => {
    if (PersonaCurso) {
      let jwt = window.localStorage.getItem("jwt");
      let idCurso = PersonaCurso[0].idCurso;
      ListarUnidadesPorCurso({ jwt, idCurso }).then((data) => {
        setListaUnidades(data);
        var posicion = data.findIndex(
          (unidad) => unidad.idUnidad === parseInt(idUnidad)
        );
        setUnidadIndex(posicion + 1);
      });
    }
  }, [PersonaCurso]);

  useEffect(() => {
    if (idEvaluacion && idEvaluacion > 0) {
      let jwt = window.localStorage.getItem("jwt");
      let id = idEvaluacion;
      BuscarEvaluacionPorId({ jwt, id }).then((data) => {
        setEvaluacion(data);
      });
    }
  }, [idEvaluacion]);

  useEffect(() => {
    if (idEvaluacion) {
      let jwt = window.localStorage.getItem("jwt");
      let id = idEvaluacion;
      ObtenerRespuestaAlumnosPorEvaluacion({ jwt, id }).then((data) => {
        var preg = data;
        var preguntasPaginadas = localStorage.getItem(
          "preguntasAleatoriasOrden"
        );

        preguntasPaginadas = JSON.parse(preguntasPaginadas);

        let totalPreguntas = preguntasPaginadas.length;
        let cortarPreguntas = preg.slice(0, totalPreguntas);
        if (preguntasPaginadas !== null) {
          cortarPreguntas = cortarPreguntas.sort((a, b) => {
            const indexA = preguntasPaginadas.findIndex(
              (resp) => resp.idPregunta === a.idPregunta
            );
            const indexB = preguntasPaginadas.findIndex(
              (resp) => resp.idPregunta === b.idPregunta
            );
            return indexA - indexB;
          });
        } else {
          console.error("preguntasPaginadas is null");
        }
        setRespuestasAlumnos(cortarPreguntas);
      });
    }
  }, [idEvaluacion]);
  useEffect(() => {
    if (idUnidad) {
      let jwt = window.localStorage.getItem("jwt");
      let id = idUnidad;
      ObtenerAlternativasPorUnidad({ jwt, id }).then((data) => {
        setListaAlternativas(data);
      });
    }
  }, [idUnidad]);
  const obtenerEstadoNota = () => {
    let aprobado = false;
    if (evaluacion) {
      if (parseInt(evaluacion.nota) >= parseInt(notaMinima)) {
        aprobado = true;
      } else {
        aprobado = false;
      }
      return aprobado;
    } else {
      return aprobado;
    }
  };

  const Decrypt = (cipherText) => {
    const key = CryptoJS.enc.Utf8.parse('0123456789abcdef');
    const iv = CryptoJS.enc.Utf8.parse('abcdef0123456789');
  
    const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
  
    return decrypted.toString(CryptoJS.enc.Utf8);
  };

  const infoHeaderNota = (
    <div className="flex align-items-center gap-2">
      <div style={{ fontSize: "13px" }} className="containerNota">
        <span className="font-bold notaSpan">Nota: </span>
        <span
          className={classNames("resultado-examen", {
            aprobado: obtenerEstadoNota() === true,
            desaprobado: obtenerEstadoNota() === false,
          })}
          style={{ fontSize: "13px" }}
        >
          {evaluacion && evaluacion.nota + "/20"}
        </span>
      </div>
      <div className="btnRegresarMovil">
        <Link
          to={`/Inicio/CursoInterno/${IdPersonaCurso}`}
          style={{ width: "240px" }}
          replace
        >
          <ButtonZegel
            label="Regresar"
            color="primary"
            className=""
          //onClick={() => handleEnviar(false)}
          //loading={loading}
          ></ButtonZegel>
        </Link>
        {/* <ButtonZegel
            label="Regresar a la unidad"
            color ="primary"
            width ="240px"
        ></ButtonZegel> */}
      </div>
    </div>
  );
  const contenidoImage = (
    <div>
      {imagenRecurso && <img src={imagenRecurso}></img>}
      {videoRecurso && <ReactPlayer url={videoRecurso}></ReactPlayer>}
    </div>
  );
  if (perfil === null) {
    return null;
  }
  return (
    <div className="ResultadosExamen">
      
      <div>
        <DashboardNavBarResultados
          titulo={`Resultado - Unidad ${UnidadIndex ? UnidadIndex : ""}`}
          adicionalNota={infoHeaderNota}
        />
      </div>

      <div className="content-general-navigation align-items-start ">
        <div className="ex-preguntas mb-2">
          {listaPreguntas &&
            evaluacion &&
            respuestasAlumnos &&
            listaAlternativas &&
            listaPreguntas.length > 0 &&
            listaPreguntas.map((pregunta, i) => {
              let itemRespuestaUsuario = respuestasAlumnos.find(
                (x) => x.idPregunta == pregunta.idPregunta
              );
              let objRespuesta = listaAlternativas.find(
                (x) =>
                  x.idRespuesta ==
                  (itemRespuestaUsuario ? itemRespuestaUsuario.idRespuesta : 0)
              );

              if (itemRespuestaUsuario != null) {
                correlativo = correlativo + 1;
                return (
                  <div
                    key={i}
                    className="ex-pregunta-alernativa w-full mt-3 mb-6"
                  >
                    <div
                      className="pregunta-item  pb-2 mb-2"
                      style={{ fontSize: "16px" }}
                    >{`${correlativo}. ${pregunta.titulo}`}</div>
                    <div
                      className={classNames("body-pregunta", {
                        "pr-select":
                          pregunta.idPreguntaTipo === 1 ? true : false,
                        "pr-input-respuesta":
                          pregunta.idPreguntaTipo === 2 ? true : false,
                      })}
                    >
                      {pregunta.idTipoRecurso === 2 &&
                        pregunta.recurso != "" &&
                        pregunta.recurso !== null && (
                          <div className="">
                            <ButtonImage
                              label="Ver imagen"
                              icon={
                                <img
                                  src={iconImage}
                                  style={{ height: 19 }}
                                ></img>
                              }
                              style={{ width: "199px" }}
                              onClick={() => {
                                setImagenRecurso(pregunta.recurso);
                                setShowDialogImage(true);
                              }}
                            ></ButtonImage>
                          </div>
                        )}
                      {pregunta.idTipoRecurso === 3 &&
                        pregunta.recurso != "" &&
                        pregunta.recurso !== null && (
                          <div className="">
                            <ButtonImage
                              label="Ver video"
                              icon={<img src={iconImage} height={19.5}></img>}
                              style={{ width: "199px" }}
                              onClick={() => {
                                setVideoRecurso(pregunta.recurso);
                                setShowDialogImage(true);
                              }}
                            ></ButtonImage>
                          </div>
                        )}
                      {pregunta.idPreguntaTipo === 2 ? (
                        <span className="p-input-icon-right flex align-items-center">
                          <i>
                            <img
                              src={
                                itemRespuestaUsuario.correcto
                                  ? checkCircle
                                  : closeCircle
                              }
                            ></img>
                          </i>
                          <InputText
                            className="input-respuesta"
                            placeholder="Escribir respuesta..."
                            value={
                              itemRespuestaUsuario &&
                              itemRespuestaUsuario.respuestaEscrita
                            }
                            keyfilter={"pnum"}
                          // onChange={(e) => {
                          //   apilaRespuestas(pregunta.idPregunta,e.target.value,2);
                          //   setRespuestasInput((prevState) => ({
                          //     ...prevState,
                          //     [pregunta.idPregunta]: e.target.value,
                          //   }));
                          // }}
                          ></InputText>
                        </span>
                      ) : (
                        <div
                          style={{ marginTop: 20, paddingLeft: 30 }}
                          className={classNames(
                            "flex align-items-center respuesta-alumno",
                            {
                              "r-correcta":
                                itemRespuestaUsuario &&
                                itemRespuestaUsuario.correcto === true,
                              "r-incorrecto":
                                itemRespuestaUsuario &&
                                itemRespuestaUsuario.correcto === false,
                            }
                          )}
                        >
                          {objRespuesta && objRespuesta.descripcion}
                        </div>
                      )}

                      {/* {evaluacion.intento == 1
                        ? !itemRespuestaUsuario.correcto && (
                            <div
                              className="font-bold"
                              style={{ marginTop: 8, color: "#A62D2D" }}
                            >{`*Revisar: ${pregunta.fuente}`}</div>
                          )
                        : !itemRespuestaUsuario.correcto && (
                            <div
                              className="font-bold"
                              style={{ marginTop: 8, color: "#A62D2D" }}
                            >
                              {pregunta.respuesta &&
                                `La respuesta correcta es: ${pregunta.respuesta}`}
                            </div>
                          )} */}
                    </div>
                    
                    {evaluacion.intento == 1
                      ? !itemRespuestaUsuario.correcto && (
                        <div
                          className="font-bold revisarmobile"
                          style={{ marginTop: 8, color: "#A62D2D" }}
                        >
                          {pregunta.fuente.trim()?`*Revisar: ${pregunta.fuente.trim()}`:`La respuesta correcta es: ${pregunta.respuesta}`}
                          {/* {`*Revisar: ${pregunta.fuente.trim() || pregunta.respuesta}`} */}
                          </div>
                      )
                      : !itemRespuestaUsuario.correcto && (
                        <div
                          className="font-bold revisarmobile"
                          style={{ marginTop: 8, color: "#A62D2D" }}
                        >
                          {pregunta.respuesta &&
                            `La respuesta correcta es: ${pregunta.respuesta}`}
                        </div>
                      )}
                  </div>
                );
              }
            })}
        </div>
      </div>
      <DialogImage
        visible={showDialogImage}
        onHide={() => {
          setImagenRecurso(null);
          setVideoRecurso(null);
          setShowDialogImage(false);
        }}
        contenido={contenidoImage}
      ></DialogImage>
      <FooterInterno />
    </div>
  );
};

export default ResultadosExamen;
